import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import { cmscontentURL } from '../Config/Config';

import { GET_PACKAGELIST,GET_ACTIVATEPACKAGE } from '../../actions';
var Parser = require('html-react-parser');
class List extends Component {
  
  constructor(props)
  {
    super(props); 
    this.state = {
      packagelist:'',
      totalRecord:0
    };

    var qs = require('qs');
    var admin_id = localStorage.getItem("admin_id");
    var postobject = {
    activePage: 1,
    search_all: '',
    admin_id: admin_id
    };

    this.props.getPackageList(qs.stringify(postobject));

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);


    }

   
   componentDidMount() {
      document.title = PageTitle('Package List');
      if(localStorage.getItem('admin_id') === null){
      this.props.history.push('/');
      }
   }

    handlePageChange(pageNumber) {
     // console.log(`active page is ${pageNumber}`);
      this.setState({activePage: pageNumber});

      var qs = require('qs');

      var admin_id = localStorage.getItem("admin_id");

      var postobject = {
        activePage: pageNumber,
        search_all: this.state.search_all,
        admin_id: admin_id
      };
      this.props.getPackageList(qs.stringify(postobject))
    }

    handleInputChange(event) {
    const {name, value} = event.target;      
    this.setState({
      [name]: value
    });
    
  }
   handleFormSubmit = () => {
        
          this.setState({Loading:true});
          var qs = require('qs');
          const formPayload = this.state;
           var admin_id = localStorage.getItem("admin_id");
          var postObject = {             
            activePage   : 1,
            search_all : formPayload.search_all,
            admin_id: admin_id         
          };
          //console.log(postObject);
          this.props.getPackageList(qs.stringify(postObject));
        
    } 


   componentWillReceiveProps(Props){

    if (Object.keys(Props.packagelist).length > 0) {
      if (Props.packagelist[0]["status"] === "success") {
       
         this.setState({ totalRecord : Props.packagelist[0].records_count, packagelist: Props.packagelist[0]["packagelist"] }, function() {
            this.packagelist();
         });
      }
    }
	
	if(Props.priorityupdate !==  this.props.priorityupdate){
      if (Props.priorityupdate[0]["status"] === "success") {
         this.props.getPackageList();
      }
    }

      if(Props.packageactive !== this.props.packageactive){
      if (Props.packageactive[0]["status"] === "success") {
              var qs = require('qs');
              var admin_id = localStorage.getItem("admin_id");
              var postobject = {
              activePage: 1,
              search_all: '',
              admin_id: admin_id
              };

              this.props.getPackageList(qs.stringify(postobject));

      }
    }

	
   }
   
activateuser(id, status){
  let stat = ''
    if(status == 'Inactive'){
      stat = "A";
    }else{
      stat = "I";
    }
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          id  :id,
          status: stat
        };
      this.props.getActivatePackage(qs.stringify(postObject));
}
  packagelist() {

    var packagelist = this.props.packagelist[0];
    if (packagelist != "undefined" && packagelist != null) {

      if (packagelist.status == "success") {

        if (Object.keys(packagelist).length > 0) {
          const vehiclelistDetails = packagelist.packagelist.map(
            (packagelist, Index) => {
              let sno = Index+1;
              console.log(packagelist.status)
              if(packagelist.status == 'A'){
                var status = 'Active';
              }else{
                  status = 'Inactive';
              }

            var string = '';
            if (packagelist.package_content!=='' && packagelist.package_content.length > 25) {
              string = packagelist.package_content.substring(0, 150) + "...";
              var stripedHtml_one = string.replace(/<[^>]+>/g, '');
              var stripedHtml =stripedHtml_one.replace(/&nbsp;/g,'');
              console.log('stripedHtml',stripedHtml)
            }

         

			       var istyle = { width: 100};
              return (
                <tr key={packagelist.id}>
                    <td>{sno}</td>
                    <td>{packagelist.type}</td>
                    <td>{stripedHtml}</td>
                    <td>{packagelist.price}</td>
                    <td>{status}</td>
                     {localStorage.getItem('loggedas') === 'admin' &&
                      <> 
                    <td className="actiongroup">
                      <Link to={{ pathname: '/package/edit/'+packagelist.id}} className="" title="Duplicate">  <i className="fa fa-edit" aria-hidden="true"></i></Link>
                       {(status == 'Active'?<Link onClick={this.activateuser.bind(this, packagelist.id, status)} className="" title="Status"><i className="fa fa-unlock" aria-hidden="true"></i></Link>:<Link onClick={this.activateuser.bind(this, packagelist.id, status)} className="" title="Status"><i className="fa fa-lock" aria-hidden="true"></i></Link>)}     
                    </td>
                    </>}
                </tr>
              );
            }
          );
          return vehiclelistDetails;
        }
      } else {

        return (
          <tr>
            <td colspan="6" className="v-align-nr">
              No Result
            </td>
          </tr>
        );

      }
    }

  }
  
  render() {

    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="packages" />  
      
      <div className="content"> 
        <div className="content-wrapper">
            <div className="car-listing-wrap">

              <div className="listing-header">
                <div className="title">
                  <h3>Packages</h3>
                </div>

                <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                 </form>
                </div>
                {this.state.totalRecord < 2 && 
                  <div className="add_button">  
                      <a className="add" href='/package-add'>Add</a> 
                  </div>
                }  
              </div>            
              {/*<div className="statusmessage"></div>*/}

              <div className="car-listing-row">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>S.NO</th>
                      <th>Package Name</th>
                      <th>Package Description</th>
                      <th>Package Price</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>{this.packagelist()}</tbody>
                </Table>
                <div className="text-center">
                  <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>

            </div> 
        </div>  
      </div>
      
    </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    packagelist: state.packagelist,
    packageactive: state.packageactive
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getPackageList: (formVal) =>{
       dispatch({ type: GET_PACKAGELIST, formVal});
    },
    getActivatePackage: (formPayload) =>{
      dispatch({ type: GET_ACTIVATEPACKAGE, formPayload });
    },
  }
}
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(List));